import { crud } from "./crud";
import { httpPost } from "../services/http";

const defaultState = [];

export const drivers = (state = defaultState, action) => crud('drivers', state, action);

export const getDrivers = () => {
	return (dispatch, state) => {
		if (state().drivers.length === 0)
			httpPost('/drivers/getAll', {}).then(data => {
				dispatch({
					type: 'drivers_add',
					data: data
				})
			});
	}
};

export const saveDriver = (data) => {
	return (dispatch, state) => {
		let link = '/drivers/';
		if (data._id) {
			link += 'update';
		} else {
			link += 'add';
		}
		httpPost(link, data).then(res => {
			if (!data.errors)
				dispatch({
					type: 'hide_modal'
				});
			dispatch({
				type: data._id ? 'drivers_update' : 'drivers_addToStart',
				data: data._id ? res : [res]
			})
		});
	}
};